/**
 * Created by andrey on 24.08.17.
 */

const NutCellView = BaseCellView.extend({
    ctor: function (nutCell) {
        this._super();

        this.setContentSize(cleverapps.styles.BaseCellView.CELL_SIZE_PX, cleverapps.styles.BaseCellView.CELL_SIZE_PX);
        this.setAnchorPoint(0.5, 0.5);

        const image = new cc.Sprite(this.getImage(nutCell));
        this.image = image;
        this.image.setPosition(this.width / 2, this.height / 2);
        this.addChild(image);

        this.initialize(nutCell);
    },

    initialize: function (nutCell) {
        this._super(nutCell);

        nutCell.onChangeLivesListener = this.createListener(this.changeLives.bind(this));
    },

    getImage: function (nutCell) {
        const bundle = nutCell.bundleId();
        return bundles[bundle].frames[bundle + nutCell.lives];
    },

    changeLives: function () {
        this.image.setSpriteFrame(this.getImage(this.cell));
    },

    unuse: function () {
        this.cell.onChangeLivesListener = function () {};

        this._super();
    },

    smile: function () {
        if (this.smiling) {
            return;
        }

        const bundle = this.cell.bundleId();
        this.smiling = BaseAnimation.factoryLimited(bundles[bundle].jsons[`${bundle}_spine_json`]);
        this.smiling.setPosition(this.width / 2, this.height / 2);
        this.addChild(this.smiling);
        this.smiling.runAnimate("smile", this.finishSmile.bind(this), this.image);
    },

    finishSmile: function () {
        if (this.smiling) {
            this.image.visible = true;
            this.smiling.finishAnimation();

            this.smiling = false;
        }
    },

    animateExploding: function () {
        this.setLocalZOrder(3);
        this.stopAllActions();

        this.finishSmile();

        const name = NutCellView.animations[this.cell.lives];
        const bundle = this.cell.bundleId();
        const animation = BaseAnimation.factoryLimited(bundles[bundle].jsons[`${bundle}_spine_json`]);
        animation.setPosition(this.width / 2, this.height / 2);
        this.addChild(animation);
        animation.runAnimate(name, () => {
            this.delete();
        }, this.image);

        cleverapps.effects.fire("match3.nut");
    },

    startExploding: function (...args) {
        if (Game.currentGame.goals.hasType(this.cell.getGoalId())) {
            this.startExplodingViaCollect(...args);
        } else {
            this.animateExploding(...args);
        }
    }
});

NutCellView.animations = {
    1: "animation_2_1",
    0: "animation_1_0"
};